import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import SimiLogo from "../../assets/simiLogo.png";
import AgencyLogo from "../../assets/asitesLogoL.png";

const FooterContainer = styled.footer`
  padding: 100px 20px 40px;
  background-color: #f4efed;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TopSection = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 50px;
    align-items: center;
    text-align: center;
  }
`;

const LogoSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  img {
    width: 200px;
  }

  .address {
    font-size: 0.9rem;
    color: #a38d92;
    line-height: 1.6;
  }
`;

const NavSide = styled.div`
  display: flex;
  gap: 80px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    align-items: center;
  }
`;

const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  h4 {
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 0.8rem;
    color: #a38d92;
    margin-bottom: 5px;
  }

  a {
    text-decoration: none;
    color: #1a1a1a;
    font-size: 0.9rem;
    transition: color 0.3s ease;

    &:hover {
      color: #a38d92;
    }
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;

  a {
    font-size: 1.2rem;
    color: #1a1a1a;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-3px);
      color: #a38d92;
    }
  }
`;

const BottomLegal = styled.div`
  width: 100%;
  max-width: 1200px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-size: 0.75rem;
  color: #a38d92;

  .legal-links {
    display: flex;
    gap: 20px;

    a {
      text-decoration: none;
      color: inherit;
      &:hover {
        color: #1a1a1a;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const AgencyBranding = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  opacity: 0.6;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 1;
  }

  span {
    font-size: 0.7rem;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  img {
    height: 60px; /* Adjust based on your logo shape */
    filter: grayscale(1);
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <TopSection>
        <LogoSide>
          <img src={SimiLogo} alt="" />
          <div className="address">
            <br />
            München, Sendling Westpark
          </div>
          <SocialIcons>
            <a href="https://instagram.com/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="#">
              <FaWhatsapp />
            </a>
            <a href="#">
              <FaEnvelope />
            </a>
          </SocialIcons>
        </LogoSide>

        <NavSide>
          <LinkGroup>
            <h4>Navigation</h4>
            <a href="#home">Home</a>
            <a href="#about">About</a>
            <a href="#pricing">Preise</a>
            <a href="#faq">FAQ</a>
          </LinkGroup>
          <LinkGroup>
            <h4>Service</h4>
            <a href="#lashes">Wimpern</a>
            <a href="#pmu">Powderbrows</a>
            <a href="#contact">Kontakt</a>
          </LinkGroup>
        </NavSide>
      </TopSection>

      <BottomLegal>
        <div>© {currentYear} Simona. All rights reserved.</div>
        <div className="legal-links">
          <a href="/impressum">Impressum</a>
          <a href="/datenschutz">Datenschutz</a>
          <a href="/agb">AGB</a>
        </div>
      </BottomLegal>

      <AgencyBranding>
        <span>Designed & Developed by</span>
        <img src={AgencyLogo} alt="Your Agency" />
      </AgencyBranding>
    </FooterContainer>
  );
};

export default Footer;
